<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'taxes', params: { idBusiness: idBusiness } }">{{
                                $t("gestionImpuestos") }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ action }} {{ $t("tax") }}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{ nombreNegocio }}</h2>
                            <hr>
                        </div>

                        <!-- Campo taxType (Seleccionable) -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="taxType"><strong>{{ $t("taxType") }} <span
                                            style="color: red">*</span></strong></label>
                                <select class="form-control" id="taxType" v-model="tax.taxType" required>
                                    <option value="Gastos" selected>Gastos</option>
                                    <!-- <option value="Ventas" disabled>Ventas</option> -->
                                </select>
                            </div>
                        </div>

                        <!-- Campo taxRate (Números y decimales) -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="taxRate"><strong>{{ $t("taxRate") }} <span
                                            style="color: red">*</span></strong></label>
                                <input type="text" class="form-control" id="taxRate" v-model="tax.taxRate"
                                    placeholder="Ej: 21.00 o 7.5" required @input="validateTaxRate"
                                    @blur="validateOnBlur" ref="taxRate">
                            </div>
                        </div>

                        <!-- Campo description (Opcional, máx. 50 caracteres) -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="description"><strong>{{ $t("descripcion") }}</strong></label>
                                <input type="text" class="form-control" id="description" v-model="tax.description"
                                    maxlength="50" placeholder="Descripción opcional">
                                <small class="form-text text-muted">{{ tax.description.length }}/50</small>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <!-- Switch de Baja -->
                                <div class="form-group">
                                    <label>
                                        <strong>{{ $t("baja") }}</strong>
                                    </label>
                                    <el-switch v-model="tax.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" @click="saveTax" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{ $t("guardar") }}
                            </button>
                            <router-link :to="{ name: 'taxes', params: { idBusiness: idBusiness, 'pag': pag } }">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{ $t("cancelar") }}
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import swal from 'sweetalert2'
import { Checkbox, Switch } from 'element-ui';
import { Loading } from 'element-ui';

export default {
    props: ['idBusiness', 'idTax', 'pag'],
    created() {
        this.action = this.idTax ? this.$i18n.t("editar") : this.$i18n.t("nuevo");

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

        this.identificacionNegocio();
        if (this.idTax) {
            this.getTax();
        }
        else {
            this.loadingGeneral.close();
        }
    },
    components: {
        [Switch.name]: Switch
    },
    mounted() {
        this.$refs.taxRate.focus();
    },
    data() {
        return {

            loadingGeneral: null,
            tax: {
                taxType: "Gastos",
                taxRate: "",
                description: "",
                baja: false
            },
            checkSelectAll: false,
            listBusinesses: [],
            minTaxRate: "0.01",
            action: "",
            inProgress: false,
            nombreNegocio: "",
        }
    },
    methods: {
        identificacionNegocio() {

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.nombreNegocio = response.data.result

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },
        checkCampos() {
            if (parseFloat(this.tax.taxRate) < parseFloat(this.minTaxRate)) {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('impuestoAplicadoEsCero') + this.minTaxRate + '%',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return false;
            } else {
                return true;
            }
        },
        getTax() {

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    idTax: this.idTax,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'taxes/getTaxById', config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.tax = response.data.result;

                        vm.loadingGeneral.close();
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },
        saveTax() {
            // if (this.checkCampos()) {
                this.inProgress = true;
                // console.log(this.tax.baja);

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                var params = {
                    idTax: this.idTax || undefined,
                    idBusiness: this.idBusiness,
                    taxType: this.tax.taxType,
                    taxRate: this.tax.taxRate,
                    description: this.tax.description,
                    baja: this.tax.baja || false,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                let controller = this.idTax ? "editTaxById" : "newTaxByBusiness";

                this.axios.post(this.$store.getters.apiUrl + 'taxes/' + controller, params, config)
                    .then(function (response) {
                        // console.log(response);
                        vm.inProgress = false;

                        if (response.data.response) {

                            if (response.data.dup) {
                                // Caso en que el impuesto ya existe
                                let notify = vm.$t('impuestoYaCreado');
                                swal({
                                    title: vm.$t('atencion'),
                                    text: notify,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    confirmButtonText: vm.$t('ok'),
                                    type: 'error'
                                });
                            } else {
                                // Caso de creación o actualización exitosa
                                let notify = vm.idTax ? vm.$t('actualizado') : vm.$t('creado');
                                vm.$notify({
                                    message: vm.$t('tax') + ' ' + notify + ' ' + vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });
                            }
                        } else {
                            // Caso de error
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            // }
        },
        validateTaxRate(event) {
            const input = event.target;
            let value = input.value;

            value = value.replace(/[^0-9.,]/g, '').replace(/,/g, '.');

            if (value.startsWith('.')) {
                value = '0' + value;
            }

            if (value == "100") {
                input.value = "100";
                this.tax.taxRate = "100";
                return;
            }

            if (value.length > 2 && !value.includes('.') && !value.includes(',')) {
                input.value = "100";
                this.tax.taxRate = "100";
            } else {
                const parts = value.split('.');
                if (parts.length > 2) {
                    value = parts[0] + '.' + parts[1].slice(0, 2);
                } else if (parts.length === 2 && parts[1].length > 2) {
                    value = parts[0] + '.' + parts[1].slice(0, 2);
                }

                if (parseFloat(value) > 100) {
                    input.value = "100";
                    this.tax.taxRate = "100";
                } else if (value.length === 3 && value === "100") {
                    input.value = "100";
                    this.tax.taxRate = "100";
                } else {
                    input.value = value;
                    this.tax.taxRate = value;
                }
            }
        },

        validateOnBlur(event) {
            const input = event.target;
            let value = input.value;

            if (value === "100." || value === "100") {
                input.value = "100.00";
                this.tax.taxRate = "100.00";
            } else if (value.trim() !== "" && !value.includes(".")) {
                input.value = value + ".00"
                this.tax.taxRate = value + ".00"
            } else if ((value.includes(".") && value.split(".")[1] === "")) {
                input.value = value + "00"
                this.tax.taxRate = value + "00"
            } else {
                if (value.endsWith('.')) {
                    input.value = value.slice(0, -1);
                }
                // Reemplaza cualquier entrada no válida
                value = input.value.replace(/[^0-9.]/g, '');
                if (parseFloat(value) > 100) {
                    input.value = "100";
                    this.tax.taxRate = "100";
                } else {
                    this.tax.taxRate = value;
                }
            }
        },
        selectAll() {
            if (this.checkSelectAll) {
                this.listBusinesses.forEach(function (business) {
                    business.checked = false;
                });
            } else {
                this.listBusinesses.forEach(function (business) {
                    business.checked = true;
                });
            }
        }
    }

}
</script>

<style scoped>
.card {
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Impuestos/ImpuestosForm.vue